module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "linecharts"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-sm-offset-3"
  }, [_c('div', {
    staticClass: "svg-line-container",
    attrs: {
      "id": "hbCanvas"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3706717a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HorBarcharts.vue
// module id = 37
// module chunks = 0